module.exports = __webpack_public_path__ + "static/img/valueBottom2.6a179d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newLasur/valueBottom2.png
// module id = X94g
// module chunks = 0